import { render, staticRenderFns } from "./VentanasEnturnamientoExport.vue?vue&type=template&id=1d095894"
import script from "./VentanasEnturnamientoExport.vue?vue&type=script&lang=js"
export * from "./VentanasEnturnamientoExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports